
      export default {
        mounted() { this.setBounds() },
        updated() { this.setBounds() },
        setBounds() {
          const pad = (n) => String(n).padStart(2, "0")
          const fmt = (d) =>
            `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
          const now = new Date()
          const max = new Date(now)
          max.setDate(now.getDate() + 14)
          this.el.min = fmt(now)
          this.el.max = fmt(max)
        },
      }
    